class MediaGalleryWrapper extends HTMLElement {
  nextButton;
  innerSliderClone;
  innerSliderClone2;
  scrollStartPosition;
  scrollFinalPosition;
  sliderItemOffset;
  activeIndex = 0;
  activeIndexGallery = 0;

  mobileButtonLeft;
  mobileButtonRight;
  galleryItem;
  isScrollable;

  constructor() {
    super();
    window.addEventListener('resize', this.onResize);

    this.slider = this.querySelector('[id^="Slider-Thumbnails"]');
    this.gallery = this.querySelector('[id^="Slider-Gallery"]');
    this.nextButton = this.querySelector('button[name="next-thumbnails"]');
    this.galleryItem = this.gallery.querySelector('[id^="Slide-"]');
    this.innerSlider = this.querySelector('#Slider-inner');
    this.innerSliderItems = this.innerSlider.querySelectorAll('[id^="Slide-"]');
    this.mobileButtonLeft = this.querySelector('#Slider-Gallery-Button-Left');
    this.mobileButtonRight = this.querySelector('#Slider-Gallery-Button-Right');

    this.sliderItemOffset = this.getSliderItemOffset();

    this.initMobileGalleryControls();

    this.innerSliderItems.forEach((sliderItem) => {
      sliderItem.addEventListener('click', () => {
        if (this.isScrollable) {
          this.setSlidePositionInstant(sliderItem.offsetLeft, this.slider, 'horizontal');
          this.syncAfterScroll();
        } else {
          this.activeIndex = parseInt(sliderItem.dataset.mediaPosition) - 1;
          this.setActiveMedia(this.sliderItems[this.activeIndex].dataset.target);
        }
      });
    });

    this.isScrollable = this.getIsScrollable();

    if (this.isScrollable) {
      this.createClones();
    }

    const debouncedScroll = debounce(this.setActiveElement, 200);
    this.sliderItems = this.slider.querySelectorAll('[id^="Slide-"]');
    this.slider.addEventListener('scroll', debouncedScroll);
    this.slider.addEventListener('scroll', this.resetScrollPosition);

    this.gallery.addEventListener('scroll', this.handleGalleryScroll);

    this.nextButton.addEventListener('click', this.onNextSlideButtonClick);
  }

  getSliderItemOffset = () => {
    if (this.innerSliderItems.length < 2) return 0;
    return this.innerSliderItems[1].offsetLeft - this.innerSliderItems[0].offsetLeft;
  };

  getIsScrollable = () => {
    return (
      window.innerWidth >= 990 &&
      this.sliderItemOffset > 0 &&
      this.sliderItemOffset * this.innerSliderItems.length >= this.slider.clientWidth
    );
  };

  onResize = () => {
    this.activeIndex = 0;
    this.activeIndexGallery = 0;
    this.setSlidePositionInstant(0, this.slider, 'horizontal');
    this.setActiveMedia(this.sliderItems[this.activeIndex].dataset.target);

    this.setSlidePositionInstant(0, this.gallery, 'horizontal');

    this.sliderItemOffset = this.getSliderItemOffset();
    this.isScrollable = this.getIsScrollable();
    this.cloneFirst = this.querySelector('#Slider-inner-clone');
    this.cloneSecond = this.querySelector('#Slider-inner-clone-2');

    if (this.isScrollable) {
      if (!this.cloneFirst && !this.cloneSecond) {
        this.createClones();
      }
    } else {
      if (this.cloneFirst) this.slider.removeChild(this.cloneFirst);
      if (this.cloneSecond) this.slider.removeChild(this.cloneSecond);
    }
  };

  scrollGalleryXAxis = (scrollToRight = true) => {
    this.setSlidePosition(
      scrollToRight
        ? this.gallery.scrollLeft + this.galleryItem.clientWidth
        : this.gallery.scrollLeft - this.galleryItem.clientWidth,
      this.gallery,
      'horizontal'
    );
  };

  initMobileGalleryControls = () => {
    this.mobileButtonRight.addEventListener('click', () => this.scrollGalleryXAxis(true));

    this.mobileButtonLeft.addEventListener('click', () => this.scrollGalleryXAxis(false));
  };

  handleGalleryScroll = () => {
    const offsetFix = 1;
    this.activeIndexGallery = Math.ceil(this.gallery.scrollLeft / this.galleryItem.clientWidth) - offsetFix;

    this.allSliderDots = this.querySelectorAll('[name="slider-counter__slide-dot"]');
    this.allSliderDots?.forEach((dotNode) => {
      if (dotNode) {
        dotNode.classList.remove('slider-counter__slide-dot--active');

        if (dotNode.dataset.sliderDotCount === String(this.activeIndexGallery + 1)) {
          dotNode.classList.add('slider-counter__slide-dot--active');
        }
      }
    });

    if (this.activeIndexGallery >= 1) {
      if (this.mobileButtonLeft.style.visibility != 'visible') this.mobileButtonLeft.style.visibility = 'visible';
    } else {
      if (this.mobileButtonLeft.style.visibility != 'hidden') this.mobileButtonLeft.style.visibility = 'hidden';
    }

    if (this.activeIndexGallery >= this.innerSliderItems.length - 1) {
      if (this.mobileButtonRight.style.visibility != 'hidden') this.mobileButtonRight.style.visibility = 'hidden';
    } else {
      if (this.mobileButtonRight.style.visibility != 'visible') this.mobileButtonRight.style.visibility = 'visible';
    }
  };

  createClones = () => {
    const slidersGap = 10;
    // clone 1 kid
    this.innerSliderClone = this.innerSlider.cloneNode(true);
    this.innerSliderClone.id = 'Slider-inner-clone';
    this.slider.appendChild(this.innerSliderClone);

    // clone 2 kid
    this.innerSliderClone2 = this.innerSlider.cloneNode(true);
    this.innerSliderClone2.id = 'Slider-inner-clone-2';
    this.slider.appendChild(this.innerSliderClone2);

    this.innerSliderCloneItems = this.innerSliderClone.querySelectorAll('[id^="Slide-"]');
    this.innerSliderClone2Items = this.innerSliderClone2.querySelectorAll('[id^="Slide-"]');

    this.innerSliderCloneItems.forEach((sliderItem) => {
      sliderItem.addEventListener('click', () => {
        this.scrollStartPosition = sliderItem.offsetLeft;
        this.scrollFinalPosition = sliderItem.offsetLeft - this.innerSlider.clientWidth - slidersGap;
        this.setSlidePositionInstant(sliderItem.offsetLeft, this.slider, 'horizontal');
        this.syncAfterScroll();
      });
    });

    this.innerSliderClone2Items.forEach((sliderItem) => {
      sliderItem.addEventListener('click', () => {
        const endScrolllPosition = sliderItem.offsetLeft - this.innerSlider.clientWidth - slidersGap;
        this.setSlidePositionInstant(this.slider.scrollLeft - this.innerSlider.clientWidth, this.slider, 'horizontal');

        setTimeout(() => {
          this.setSlidePositionInstant(endScrolllPosition, this.slider, 'horizontal');
          this.syncAfterScroll();
        }, 100);
      });
    });
  };

  setActiveMedia = (mediaId) => {
    const activeMedia =
      this.gallery.querySelector(`[data-media-id="${mediaId}"]`) || this.gallery.querySelector('[data-media-id]');
    if (!activeMedia) {
      return;
    }
    this.gallery.querySelectorAll('[data-media-id]').forEach((element) => {
      element.classList.remove('is-active');
    });
    activeMedia?.classList?.add('is-active');
  };

  syncAfterScroll = () => {
    this.resetScrollPosition();
    this.setActiveElement();
  };

  resetScrollPosition = () => {
    if (!this.isScrollable) return;
    // loop back to correct position
    const currentScroll = this.slider.scrollLeft;
    if (this.scrollStartPosition) {
      if (currentScroll === this.scrollStartPosition) {
        this.setSlidePositionInstant(this.scrollFinalPosition, this.slider, 'horizontal');
        this.scrollStartPosition = undefined;
        this.scrollFinalPosition = undefined;
      }
    } else if (currentScroll >= this.innerSlider.clientWidth) {
      this.setSlidePositionInstant(0, this.slider, 'horizontal');
    }
  };

  setActiveElement = () => {
    if (!this.isScrollable || !this.sliderItemOffset) return;
    const currentScroll = this.slider.scrollLeft;
    //setting active index and active media
    const newActiveIndex = Math.floor(currentScroll / this.sliderItemOffset);
    if (newActiveIndex !== this.activeIndex) {
      this.activeIndex = newActiveIndex;
    }

    this.setActiveMedia(this.sliderItems[this.activeIndex].dataset.target);
  };

  setSlidePosition = (position, element, direction) => {
    if (direction === 'horizontal') {
      element.scrollTo({
        left: position,
      });
    } else {
      element.scrollTo({
        top: position,
      });
    }
  };

  setSlidePositionInstant = (position, element, direction) => {
    if (direction === 'horizontal') {
      element.scrollTo({
        left: position,
        behavior: 'instant',
      });
    } else {
      element.scrollTo({
        top: position,
        behavior: 'instant',
      });
    }
  };

  onNextSlideButtonClick = () => {
    if (this.isScrollable) {
      const currentScroll = this.slider.scrollLeft;
      const current = Math.floor(currentScroll / this.sliderItemOffset);
      this.setSlidePositionInstant(current * this.sliderItemOffset + this.sliderItemOffset, this.slider, 'horizontal');
      this.syncAfterScroll();
    } else {
      if (this.activeIndex === this.innerSliderItems.length - 1) {
        this.activeIndex = 0;
      } else {
        this.activeIndex += 1;
      }
      this.setActiveMedia(this.sliderItems[this.activeIndex].dataset.target);
    }
  };
}
customElements.define('media-gallery-wrapper', MediaGalleryWrapper);
